import React, { useState } from "react";
import Alert from "../../../Components/alert/Alert";
import TextField from "../../../Components/textField/textField";
import Select from "../../../Components/select/select";
import Button from "../../../Components/commonButton/commonButton";
import Api from "../../../services/api";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import { Checkbox } from "../../../Components/Checkbox/checkbox";

const AddUser = () => {
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const [reload, setReload] = useState(false);

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [level, setLevel] = useState("");
  const [password, setPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [admin, setAdmin] = useState(false);
  const [validated, setValidated] = useState(true);

  const [notification, setNotification] = useState(false);
  const [notification_type, setNotificationType] = useState("success");
  const [notification_message, setNotificationMessage] = useState("");

  const levels = [
    { value: "Insp./Prep./Ferram.", label: "Insp./Prep./Ferram." },
    { value: "Supervisor", label: "Supervisor" },
    { value: "Coordenador", label: "Coordenador" },
    { value: "Gerente", label: "Gerente" },
    { value: "Diretor", label: "Diretor" },
  ];

  //Validando o formulário
  const validationForm = () => {
    if (email.length > 320) {
      setMessage("O campo e-mail pode ter no máximo 320 caracteres.");
      setShow(true);
      return false;
    }

    if (username.length > 20) {
      setMessage("O campo usuário pode ter no máximo 20 caracteres.");
      setShow(true);
      return false;
    }

    if (
      username == "" ||
      email == "" ||
      level == "" ||
      password == "" ||
      confPassword == ""
    ) {
      setMessage("Erro! Todos os dados devem ser preenchidos.");
      setShow(true);
      return false;
    }

    if (password != confPassword) {
      setMessage("Erro! As senhas não conferem.");
      setShow(true);
      return false;
    }

    return true;
  };

  //Função para enviar dados aos backend
  const sendData = () => {
    if (validationForm() == true) {
      Api.post("/register/", {
        username: username,
        email: email,
        level: level,
        password: password,
        is_admin: admin == true ? 1 : 0,
        is_validated: validated == true ? 1 : 0,
        id_employee: null,
      })
        .then((response) => {
          setNotification(true);
          setNotificationType("success");
          setNotificationMessage("Usuário cadastrado com sucesso!");
          setTimeout(() => {
            return window.location.reload();
          }, 2000);
        })
        .catch((error) => {
          error.response.status == 400
            ? setMessage(
                "Erro ao adicionar usuário! Erro: " +
                  error.response.data.error +
                  " " +
                  "Verifique os dados informados."
              )
            : error.response.status == 500
            ? setMessage(
                "Erro ao adicionar usuário! Erro: " +
                  error.response.data.error +
                  " " +
                  "Tente novamente mais tarde."
              )
            : null;
          setShow(true);
        });
    }
  };

  //Função para fechar o alerta
  const callbackfunction = () => {
    setShow(false);
  };

  //Função para armazenar o usuário
  const callbackUsername = (value) => {
    setUsername(value);
  };

  //Função para armazenar o email
  const callbackEmail = (value) => {
    setEmail(value);
  };

  //Função para armazenar o level
  const callbackLevel = (value) => {
    setLevel(value);
  };

  //Função para armazenar a senha
  const callbackPassword = (value) => {
    setPassword(value);
  };

  //Função para armazenar a confirmação da senha
  const callbackConfPassword = (value) => {
    setConfPassword(value);
  };

  const callbackAdmin = (value) => {
    setAdmin(value);
  };

  const callbackValidated = (value) => {
    setValidated(value);
  };

  return (
    <div className="box">
      {notification == true ? (
        <>
          <Notification
            message={notification_message}
            type={notification_type}
          ></Notification>
          <Loading></Loading>
        </>
      ) : (
        <></>
      )}
      {show ? (
        <Alert
          show={show}
          message={message}
          parentCallback={callbackfunction}
          reload={reload}
        />
      ) : null}
      <form className="form">
        <h4>Adicionar Usuários</h4>
        <div className="inputs">
          <div className="element">
            <TextField
              max={20}
              title={"Usuário"}
              validationType={"varchar"}
              parentCallback={callbackUsername}
            ></TextField>
          </div>
          <div className="element">
            <TextField
              max={320}
              title={"E-mail"}
              parentCallback={callbackEmail}
            ></TextField>
          </div>
          <div className="element">
            <Select
              label={"Nível ANDON"}
              arrData={levels}
              handleSelect={callbackLevel}
            ></Select>
          </div>
          <div className="element">
            <TextField
              max={60}
              title={"Senha"}
              validationType={"varchar"}
              typeValue={"password"}
              parentCallback={callbackPassword}
            ></TextField>
          </div>
          <div className="element">
            <TextField
              max={60}
              title={"Confirme a senha"}
              validationType={"varchar"}
              typeValue={"password"}
              parentCallback={callbackConfPassword}
            ></TextField>
          </div>
          <div className="checkboxs">
            <Checkbox
              label="Administrador"
              id="administrador"
              checked={admin}
              setIsActive={callbackAdmin}
            />
          </div>
        </div>
        <div className="submitButton">
          <Button
            icon="add"
            parentCallback={sendData}
            title="Adicionar"
          ></Button>
        </div>
      </form>
    </div>
  );
};

export default AddUser;
